import { useQuery } from "@tanstack/react-query";
import { getRecentPosts } from "../../api/apiStorefront";
import i18next from "i18next";

/**
 * Hook to fetch recent blog posts
 * @param {Object} params - Query parameters
 * @param {number} params.limit - Number of posts (default: 5)
 */
export function useGetRecentPosts(params = {}) {
    const {
        isLoading,
        data,
        error,
        refetch,
    } = useQuery({
        queryKey: ["recentPosts", i18next.language, params],
        queryFn: () => getRecentPosts(params),
        retry: false,
        staleTime: 1000 * 60 * 3, // 3 minutes (recent posts change more often)
        cacheTime: 1000 * 60 * 5, // 5 minutes
    });

    const posts = data?.data?.data || [];

    return { isLoading, error, posts, refetch };
}
